import { addLocale } from 'primereact/api';

// information from https://github.com/primefaces/primelocale

import { LanguagesEnum } from '@/api/enums';
import translationDEV from '@/locales/dev_translations.json';
import da from '@/locales/localazy/da.json';
import de from '@/locales/localazy/de.json';
import en from '@/locales/localazy/en-US.json';
import nb from '@/locales/localazy/nb.json';
import nl from '@/locales/localazy/nl.json';
import sv from '@/locales/localazy/sv.json';

type CalendarTranslation = {
  firstDayOfWeek: number;
  clear: string;
  dayNames: string[];
  dayNamesShort: string[];
  dayNamesMin: string[];
  monthNames: string[];
  monthNamesShort: string[];
  am: string;
  pm: string;
  today: string;
};

const translate = (lang: CalendarTranslation) => ({
  firstDayOfWeek: 1, // 1 = Monday, 0 = Sunday
  clear: lang.clear,
  dayNames: lang.dayNames,
  dayNamesShort: lang.dayNamesShort,
  dayNamesMin: lang.dayNamesMin,
  monthNames: lang.monthNames,
  monthNamesShort: lang.monthNamesShort,
  am: lang.am,
  pm: lang.pm,
  today: lang.today,
});

export const isThereDevTranslations = (): boolean =>
  translationDEV &&
  Object.keys(translationDEV).includes('dayNames') &&
  Array.isArray(translationDEV.dayNames) &&
  translationDEV.dayNames.length > 0;

if (process.env.REACT_APP_ENVIRONMENT === 'local' && isThereDevTranslations()) {
  addLocale(
    'en_GB',
    translate(translationDEV as CalendarTranslation & typeof translationDEV),
  );
}

export const isThereTranslation = (): boolean =>
  [da, en, sv, de, nb, nl].every(
    (locale) =>
      Object.keys(locale).length !== 0 &&
      Object.keys(locale).includes('dayNames'),
  );

if (isThereTranslation()) {
  addLocale(LanguagesEnum.EN, translate(en as CalendarTranslation & typeof en));
  addLocale(LanguagesEnum.DK, translate(da as CalendarTranslation & typeof da));
  addLocale(LanguagesEnum.SE, translate(sv as CalendarTranslation & typeof sv));
  addLocale(LanguagesEnum.NO, translate(nb as CalendarTranslation & typeof nb));
  addLocale(LanguagesEnum.NL, translate(nl as CalendarTranslation & typeof nl));
  addLocale(LanguagesEnum.DE, translate(de as CalendarTranslation & typeof de));
  // fallback to english
  addLocale(LanguagesEnum.KL, translate(en as CalendarTranslation & typeof en));
  addLocale(LanguagesEnum.FR, translate(en as CalendarTranslation & typeof en));
}
